import * as yup from 'yup'

export const FormValidations = yup.object().shape({
  responsavel: yup.string().required('Informe o nome do responsável'),
  empresa: yup.string().required('Informe o nome da empresa'),
  cidade: yup.string().required('Informe uma cidade'),
  cnpj: yup.string().required('Informe um CNPJ'),
  telefone: yup.string().required('Informe um telefone'),
  email: yup
    .string()
    .email('Infome um e-mail válido')
    .required('E-mail é obrigatório'),
  password: yup.string(),
})
